module.exports = {
	extends: [
		'/',
		'base',
		'form',
		'form'
	],

	config: {
		resourceRegisterKey: 'entityParent',
		loadWhenPrimaryKeyPresentOnly: true,
	},

	model: {
		ninjaModule: '',            // actual ninjaModule (e.g., news)
		ninjaModuleConfig: {},      // actual ninjaModuleConfig defined by web-projects clientAppConfig (e.g., appConfig.ninjaModules.news)

		entityController: null,     // parent entityController
	},

	methods: {
		onBuild(storage){
			if(storage.isServer){
				return;
			}

			if(!this.model.ninjaModule){
				this.closest('templates_ninja_controller', controller => {
					const {
						ninjaModule,
						ninjaModuleConfig
					} = controller.getNinjaModuleParams()
					this.model.ninjaModule = ninjaModule
					this.model.ninjaModuleConfig = ninjaModuleConfig

					// use modelName as fallback for privilegeBase
					const modelName = (ninjaModuleConfig.db || {}).entityModelName
					if(modelName && !this.config.privilegeBase){
						this.config.privilegeBase = modelName
					}

				}, true)

				this.closest('templates_ninja_entityController', controller => {
					this.model.entityController = controller
				}, true)
			}
		},



		////////////////////
		/// customs
		////////////////////

		getRouteName(){
			return this.getFieldValue('title')
		},

		onChange: function(isRelationChange, changeDone, fieldData){
			if((fieldData || {}).fieldCode === 'title') {
				return this.updateTabTitle('fallback', (fieldData || {}).fieldValue || '')
			}
		},

		updateTabTitle: function(langCode, partTitle){
			if(this.model.entityController){
				return this.model.entityController.updateTabTitle(langCode, partTitle)
			}
		},
	},

	handlers: [
		{
			name: 'afterCancel',
			componentClass: 'templates_ninja_propertiesForm',
			handle: function(callerComponent){
				if(callerComponent.componentIndex === this.componentIndex){
					this.refresh()
				}
			}
		},
		{
			name: 'onSubmitDone',
			componentClass: 'templates_ninja_propertiesForm',
			handle: function(callerComponent){
				if(callerComponent.componentIndex === this.componentIndex){
					this.refresh()
				}
			}
		},
	],
};
